import facts from "@/data/facts.json";

export const KNOWN = facts.known;
export const UNKNOWN = facts.unknown;
export const EXPLAINER = facts.explainer;
export const INTRO = facts.intro;

export const RESOURCES = [
  {
    group: "SpaceX Information",
    links: [
      { name: "SpaceX Official Website", url: "https://www.spacex.com/", note: "Company news, missions and updates" },
      { name: "SpaceX Updates", url: "https://www.spacex.com/updates/", note: "Official company announcements" },
      { name: "SpaceX on X", url: "https://x.com/SpaceX", note: "Official SpaceX account" },
      { name: "Elon Musk on X", url: "https://x.com/elonmusk", note: "Public posts from Elon Musk" },
    ],
  },
  {
    group: "Official Government Resources",
    links: [
      { name: "Investor.gov (SEC)", url: "https://www.investor.gov/", note: "Free investor education from the SEC" },
      { name: "SEC EDGAR Filings", url: "https://www.sec.gov/edgar/search/", note: "Search official company filings" },
      { name: "IRS: Tax on Children's Investment Income", url: "https://www.irs.gov/taxtopics/tc553", note: "The 'kiddie tax' explained" },
      { name: "FINRA BrokerCheck", url: "https://brokercheck.finra.org/", note: "Verify brokers and firms" },
      { name: "FTC: Avoiding Investment Scams", url: "https://consumer.ftc.gov/articles/what-know-about-investment-scams", note: "Spot and report scams" },
    ],
  },
  {
    group: "Children's Investment Accounts",
    links: [
      { name: "Investor.gov: Custodial Accounts (UGMA/UTMA)", url: "https://www.investor.gov/introduction-investing/investing-basics/glossary/custodial-account", note: "How accounts for minors work" },
      { name: "Investor.gov: 529 Plans", url: "https://www.investor.gov/introduction-investing/investing-basics/investment-products/529-plans", note: "Education savings basics" },
      { name: "FINRA: Saving for Education", url: "https://www.finra.org/investors/investing/investment-products/529-savings-plans", note: "Compare education savings options" },
    ],
  },
  {
    group: "Financial Education",
    links: [
      { name: "MyMoney.gov", url: "https://www.mymoney.gov/", note: "U.S. government financial literacy hub" },
      { name: "CFPB: Money as You Grow", url: "https://www.consumerfinance.gov/consumer-tools/money-as-you-grow/", note: "Teaching kids about money" },
      { name: "FINRA Investor Insights", url: "https://www.finra.org/investors/insights", note: "Plain-English investing guides" },
      { name: "Khan Academy: Personal Finance", url: "https://www.khanacademy.org/college-careers-more/personal-finance", note: "Free finance lessons" },
    ],
  },
];

export const BASICS = [
  { t: "What is a share?", d: "A share is a unit of ownership in a company. Owning one share means owning a very small piece of that company." },
  { t: "Can children own stock?", d: "In the U.S., minors usually hold investments through a custodial account managed by an adult until the child reaches the age set by state law." },
  { t: "Private vs. public companies", d: "Shares of private companies are not traded on public stock exchanges and can be harder to value or sell than publicly listed shares." },
];

export const FAQS = facts.faqs;
